/**
 * @file 特性列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import Img1 from '../../../../images/feature/1.png';
import Img2 from '../../../../images/feature/2.png';
import Img3 from '../../../../images/feature/3.png';
import Img4 from '../../../../images/feature/4.png';
import Img5 from '../../../../images/feature/5.png';

export interface IFeatureListItem {
    title: string;
    subtitle: React.ReactNode;
    img: string;
    link: string;
    target?: string;
}

const listData: IFeatureListItem[] = [
    {
        title: '同时支持动态图和静态图，兼顾灵活性和高性能',
        subtitle: '飞桨同时为用户提供动态图和静态图两种计算图。动态图组网更加灵活、调试网络便捷，实现AI 想法更快速；静态图部署方便、运行速度快，应用落地更高效',
        img: Img1,
        link: ''
    },
    {
        title: '源于实际业务淬炼，提供应用效果领先的官方模型',
        subtitle: '飞桨提供的80+官方模型，全部经过真实应用场景的有效验证。不仅包含“更懂中文”的NLP 模型，同时开源多个视觉领域国际竞赛冠军算法',
        img: Img2,
        link: '/nlptools',
        target: '_blank'
    },
    {
        title: '源于产业实践，输出业界领先的超大规模并行深度学习平台能力',
        subtitle:
            <div>
                <div>
                    飞桨同时支持稠密参数和稀疏参数场景的超大规模深度学习并行训练，支持万亿规模参数、数百个节点的高效并行训练，提供强大的深度学习并行技术
                </div>
                <div>
                    飞桨提供高性价比的多机CPU参数服务器解决方案，基于真实的推荐场景的数据验证，可有效地解决超大规模推荐系统、超大规模数据、自膨胀的海量特征及高频率模型迭代的问题，实现高吞吐量和高加速比
                </div>
            </div>,
        img: Img3,
        link: ''
    },
    {
        title: '追求极致速度体验，推理引擎一体化设计实现训练到多端推理的无缝对接',
        subtitle: <div>
            <div>
                飞桨完整支持多框架、多硬件和多操作系统，为用户提供高兼容性、高性能的多端部署能力。依托业界领先的底层加速库，利用 Paddle Lite和 Paddle Serving 分别实现端侧和服务器上的部署
            </div>
            <div>
                飞桨提供高效的自动化模型压缩库 PaddleSlim，实现高精度的模型体积优化，并提供业界领先的轻量级模型结构自动搜索Light-NAS，对比MobileNet v2在ImageNet 1000类分类任务上精度无损情况下FLOPS 减少17%（注：数据来源于内部QA测试，<a
                    href="https://github.com/PaddlePaddle/models/tree/develop/PaddleSlim ">查看详情</a>）
            </div>
        </div>,
        img: Img4,
        link: '/tools'
    },
    {
        title: '秉承用户至上理念，提供系统化技术服务与支持',
        subtitle: '飞桨提供完善的技术支持，满足不同层次的开发者的应用需求；提供系统化技术服务，致力于为企业合作伙伴保驾护航；提供领先的教育资源，支持高校和教育合作伙伴构建完善的教育体系',
        img: Img5,
        link: ''
    }
];

export default listData;
